import angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { LiveMapMetricsComponent } from './live-map-metrics.component';

export default angular
    .module('control-room.experience-promoter.live-map.live-map-metrics', [])
    .directive('crLiveMapMetrics', downgradeComponent({ component: LiveMapMetricsComponent }));
